import { environment } from "./../../../../environments/environment";
import { AuthService } from "../../../services/auth/auth.service";
import {
  getIdToken,
  irParaLogin,
  isKeycloakEnabled,
  limparSessaoKeycloak,
  limparSessaoLocal,
  reiniciarContagemDeLogin,
  temRetornoDeLogin,
  urlDeLogout,
} from "../../../services/auth/keycloak/keycloak.util";
import {
  preserveItems,
  restorePreserved,
} from "../../../services/util/local-storage-preserve.service";

export class LoginController implements angular.IController {
  public email: string;
  public password: string;
  /** Com o Keycloak ligado o formulário de e-mail e senha não existe: a tela só leva ao Keycloak. */
  public keycloakAtivo = isKeycloakEnabled();

  constructor(
    private $window: angular.IWindowService,
    private $scope: any,
    private Auth: AuthService
  ) {
    "ngInject";

    this.$window = $window;
    this.$scope = $scope;
    this.Auth = Auth;

    this.email = $window.location.search.split("?email=")[1];

    if (isKeycloakEnabled()) {
      this.entrarPeloKeycloak();
    }
  }

  /**
   * Com o Keycloak ligado a tela de login e dele: sem retorno na URL manda para o Keycloak; com o
   * retorno (?code=&state=) conclui o login. Falhou: mostra o erro e para — nao reenvia sozinho ao
   * Keycloak, que com a sessao viva devolveria o usuario e fecharia um laco de redirecionamento.
   */
  private async entrarPeloKeycloak() {
    const search = this.$window.location.search;
    try {
      if (temRetornoDeLogin(search)) {
        await this.Auth.loginKeycloak(search);
        this.$window.location.href = this.destinoPosLogin();
      } else {
        await irParaLogin();
      }
    } catch (err) {
      console.error("[keycloak] falha ao entrar:", err);
      if (err && err.status === 404) {
        // O login do Keycloak deu certo, mas o /me nao achou um Cliente para este usuario (ex.: usuario
        // interno com o perfil CLIENTE, sem ser contato de nenhum cliente). Nao deixa uma sessao pela
        // metade no storage; o logout do Keycloak so acontece se a pessoa escolher entrar com outra conta.
        this.$window.localStorage.removeItem("ls.token");
        this.$window.localStorage.removeItem("ls.user");
        this.$scope.errors =
          "Não encontramos um cliente vinculado a este usuário. Entre com outra conta.";
        this.$scope.semCliente = true;
      } else {
        if (err && err.laco) {
          // Signed in and dropped again several times in a row: stop here with a clean storage, so
          // "Tentar novamente" starts from scratch instead of from the state that looped.
          limparSessaoLocal();
        }
        this.$scope.errors =
          "Não foi possível entrar. Tente novamente em instantes.";
      }
      this.$scope.$applyAsync();
    }
  }

  /** Recomeça pelo Keycloak (sem o ?code=&state= antigo, que já foi consumido). */
  tentarNovamente() {
    this.$scope.errors = null;
    this.$scope.semCliente = false;
    reiniciarContagemDeLogin();
    irParaLogin().catch((err) => {
      console.error("[keycloak] falha ao entrar:", err);
      this.$scope.errors =
        "Não foi possível entrar. Tente novamente em instantes.";
      this.$scope.$applyAsync();
    });
  }

  /** Encerra a sessão SSO no Keycloak e volta ao login, para entrar com outro usuário. */
  entrarComOutraConta() {
    const idToken = getIdToken();
    const preservados = preserveItems();
    this.$window.localStorage.clear();
    restorePreserved(preservados);
    limparSessaoKeycloak();
    this.$window.location.assign(urlDeLogout(idToken));
  }

  async login(form) {
    this.$scope.errors = null;

    if (!form.$valid) {
      return;
    }

    try {
      const data = await this.Auth.login({
        email: this.email,
        password: this.password,
      });

      this.$window.location.href = this.destinoPosLogin();
    } catch (err) {
      switch (err.status) {
        case 403:
          if (err.data.error.code === "LOGIN0004") {
            window.location.href = `${environment.angularJSconstants.URL_SHIPPING_LABEL}/login?email=${err.data.error.message}`;
            return;
          }
          break;
      }
      this.$scope.loading = null;
      this.$scope.errors = err.data && err.data.error && err.data.error.message;
    }
  }

  /**
   * Destino após o login. Por padrão "/redirecionar" (comportamento de sempre).
   * Se houver uma returnUrl guardada (hoje só a página de download do relatório
   * SLA a grava), consome-a uma única vez e só a honra se apontar para a própria
   * página SLA — assim um valor esquecido no storage nunca redireciona pra um
   * lugar inesperado.
   */
  private destinoPosLogin(): string {
    const padrao = "/redirecionar";
    const returnUrl = localStorage.getItem("ls.returnUrl");
    localStorage.removeItem("ls.returnUrl");

    if (returnUrl && returnUrl.indexOf("/relatorios/sla/") === 0) {
      return returnUrl;
    }

    return padrao;
  }
}
